import template from './icon.vhtml';

export default {
	template: template,
	props: {
		name: {
			type: String,
		},
		width: {
			type: Number,
			default: 100,
		},
	},
	computed: {
		widthPx() {
			return `${this.width}px`;
		},
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/icon/icon.js